import React from "react";
import { useLang } from "../../i18n/LanguageContext";

/* Fine gold hairline divider with central lotus glyph */
export const GoldDivider = ({ className = "" }) => (
  <div className={"flex items-center justify-center gap-4 " + className} aria-hidden="true">
    <span className="h-px w-16 sm:w-28 bg-gradient-to-r from-transparent to-gold/60" />
    <span className="text-gold text-lg leading-none">&#10070;</span>
    <span className="h-px w-16 sm:w-28 bg-gradient-to-l from-transparent to-gold/60" />
  </div>
);

/* Small arch-topped SVG frame decoration */
export const Overline = ({ children, className = "", dark = false }) => (
  <span
    className={
      "font-cinzel text-xs tracking-luxe uppercase " +
      (dark ? "text-goldlight " : "text-gold ") +
      className
    }
  >
    {children}
  </span>
);

export const SectionHead = ({ overline, heading, sub, dark = false, center = true }) => {
  const { t } = useLang();
  return (
    <div className={center ? "text-center max-w-2xl mx-auto" : "max-w-2xl"}>
      <Overline dark={dark}>{t(overline)}</Overline>
      <h2
        className={
          "mt-4 font-serif font-light leading-[1.1] tracking-tight text-3xl sm:text-4xl lg:text-5xl " +
          (dark ? "text-ivory" : "text-maroon")
        }
      >
        {t(heading)}
      </h2>
      {sub && (
        <p
          className={
            "mt-5 text-sm sm:text-base leading-relaxed " +
            (dark ? "text-ivory/70" : "text-maroon/70")
          }
        >
          {t(sub)}
        </p>
      )}
      <GoldDivider className="mt-7" />
    </div>
  );
};
